export default "__VITE_ASSET__DpjfKc$3__"